<template>
    <div data-cy="container_modal_master">
        <AlertModal
                v-if="controller.alertModal != null"
                :controller="controller.alertModal"
                data-cy="component_modal_master_alert"
        ></AlertModal>
        <ConfirmModal
                v-if="controller.confirmModal != null"
                :controller="controller.confirmModal"
                data-cy="component_modal_master_confirm"
        ></ConfirmModal>
        <LoadingModal
                v-if="controller.loadingModal != null"
                :controller="controller.loadingModal"
                data-cy="component_modal_master_loading"
        ></LoadingModal>
        <PdpaModal
                v-if="controller.pdpaModal != null"
                :controller="controller.pdpaModal"
                data-cy="component_modal_master_pdpa"
        ></PdpaModal>
        <ConfirmRedeemModal
                v-if="controller.confirmRedeemModal != null"
                :controller="controller.confirmRedeemModal"
                data-cy="component_modal_master_confirm_redeem"
        ></ConfirmRedeemModal>
        <SerialModal
                v-if="controller.serialModal != null"
                :controller="controller.serialModal"
                data-cy="component_modal_master_serial"
        ></SerialModal>
        <DrawDeliveryModal
                v-if="controller.drawDeliveryModal != null"
                :controller="controller.drawDeliveryModal"
                data-cy="component_modal_master_draw_delivery"
        ></DrawDeliveryModal>
        <ShippingAddressModal
                v-if="controller.shippingAddressModal != null"
                :controller="controller.shippingAddressModal"
                data-cy="component_modal_master_shipping_address"
        ></ShippingAddressModal>
        <AddAddressModal
                v-if="controller.addAddressModal != null"
                :controller="controller.addAddressModal"
                data-cy="component_modal_master_add_address"
        ></AddAddressModal>
        <EditAddressModal
                v-if="controller.editAddressModal != null"
                :controller="controller.editAddressModal"
                data-cy="component_modal_master_edit_address"
        ></EditAddressModal>
        <ListAddressModal
                v-if="controller.listAddressModal != null"
                :controller="controller.listAddressModal"
                data-cy="component_modal_master_list_address"
        ></ListAddressModal>
        <AddTaxAddressModal
                v-if="controller.addTaxAddressModal != null"
                :controller="controller.addTaxAddressModal"
                data-cy="component_modal_master_add_tax_address"
        ></AddTaxAddressModal>
        <EditTaxAddressModal
                v-if="controller.editTaxAddressModal != null"
                :controller="controller.editTaxAddressModal"
                data-cy="component_modal_master_edit_tax_address"
        ></EditTaxAddressModal>
        <ListTaxAddressModal
                v-if="controller.listTaxAddressModal != null"
                :controller="controller.listTaxAddressModal"
                data-cy="component_modal_master_list_tax_address"
        ></ListTaxAddressModal>
    </div>
</template>
<script>
//generic
import AlertModal from './Generic/AlertModal/AlertModal.vue';
import ConfirmModal from "./Generic/ConfirmModal/ConfirmModal.vue";
import LoadingModal from './Generic/LoadingModal/LoadingModal.vue';
//authen
import PdpaModal from './Authen/PdpaModal/PdpaModal.vue';
//redeem
import ConfirmRedeemModal from '@/module/Detail/modal/ConfirmRedeemModal/ConfirmRedeemModal.vue';
import SerialModal from '@/module/Detail/modal/SerialModal/SerialModal.vue';
import DrawDeliveryModal from '@/module/Detail/modal/DrawDeliveryModal/DrawDeliveryModal.vue';
import ShippingAddressModal from '@/module/Detail/modal/ShippingAddressModal/ShippingAddressModal.vue';
//address
import AddAddressModal from '@/module/Address/DeliveryAddress/modal/AddAddressModal/AddAddressModal.vue';
import EditAddressModal from '@/module/Address/DeliveryAddress/modal/EditAddressModal/EditAddressModal.vue';
import ListAddressModal from '@/module/Address/DeliveryAddress/modal/ListAddressModal/ListAddressModal.vue';
import AddTaxAddressModal from '@/module/Address/TaxAddress/modal/AddTaxAddressModal/AddTaxAddressModal.vue';
import EditTaxAddressModal from '@/module/Address/TaxAddress/modal/EditTaxAddressModal/EditTaxAddressModal.vue';
import ListTaxAddressModal from '@/module/Address/TaxAddress/modal/ListTaxAddressModal/ListTaxAddressModal.vue';

export default {
    name: 'ModalMaster',
    components: {
        AlertModal,
        ConfirmModal,
        LoadingModal,
        PdpaModal,
        ConfirmRedeemModal,
        SerialModal,
        ShippingAddressModal,
        DrawDeliveryModal,
        AddAddressModal,
        EditAddressModal,
        ListAddressModal,
        AddTaxAddressModal,
        EditTaxAddressModal,
        ListTaxAddressModal,
    },
    props: {
        controller: {
            type: Object,
            required: true,
        },
    },
}
</script>
